import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import AssetUtility from '../../../classes/AssetUtility';
import TextVariables from '../../../classes/TextVariables';

export default function UIProjectOptions(props)
{
	let properties = {
		'visible': {
			type: 'toggle',
			default: true
		},
		'scenario logo': {
			type: 'image'
		},
		'company logo': {
			type: 'image'
		},
		'title': {
			type: 'text',
			default: 'Project Title'
		},
		'title color': {
			type: 'color',
			default: '#000000'
		},
		'title alpha': {
			type: 'range',
			step: 1,
			default: '80',
		},
		'subtitle': {
			type: 'text',
			default: 'Project Subtitle'
		},
		'subtitle color': {
			type: 'color',
			default: '#000000'
		},
		'subtitle alpha': {
			type: 'range',
			step: 1,
			default: '80',
		},
		'background color': {
			type: 'color',
			default: '#afafaf'
		},
		'background alpha': {
			type: 'range',
			step: 1,
			default: '50',
		},
		'anchor': {
			type: 'anchor',
			default: props.anchor ? props.anchor : 'center'
		},
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Project Options'}
				subcomponent={types.PROJECT_OPTIONS}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible.value)
	{
		const data = props.data;
		const scenarioLogo = data['scenario logo']?.value;
		const scenarioLogoSrc = scenarioLogo ? AssetUtility.getPreviewAssetURL(scenarioLogo) : null;
		const logo = data['company logo'].value;
		const logoSrc = AssetUtility.getPreviewAssetURL(logo);
		const titleColor = data['title color'].value + percentToHex(data['title alpha'].value);
		const subtitleColor = data['subtitle color'].value + percentToHex(data['subtitle alpha'].value);

		return (
			<div className={"uiProjectOptionsRoot"}
				data-anchor={data['anchor'].value}
				data-name={"ui-preview-project-options-root"}
			>
				<div className={"uiProjectOptionsLogoWL"}
					data-name={"ui-preview-project-options-worklink-logo"}
				>
					{
						!scenarioLogo ?
							<img
								alt={"WorkLink logo"}
								src={"/WorkLink.png"}
							/> :
							<img
								alt={"Scenario Logo"}
								src={scenarioLogoSrc}
							/>
					}
				</div>
				<div className={"uiProjectOptionsDetails"}
					data-name={"ui-preview-project-options-project-details"}
					style={{
						backgroundColor: data['background color'].value + percentToHex(data['background alpha'].value)
					}}
				>
					<div className={"uiProjectOptionsLogo"}
						data-name='ui-preview-project-options-logo'
					>
						{
							!logo ? null :
								<img
									alt={"Project Logo"}
									src={logoSrc}
								/>
						}
					</div>
					<div className={"uiProjectOptionsTitle"}
						data-name={"ui-preview-project-options-title"}
						style={{
							color: titleColor,
							fontSize: props.context === 'simulation' ? 30 : (14 * props.scale) + "px",
							fontWeight: "bold",
						}}
					>
						{TextVariables.textToData(data.title.value)}
					</div>
					<div className={"uiProjectOptionsSubtitle"}
						data-name={"ui-preview-project-options-subtitle"}
						style={{
							color: subtitleColor,
							fontSize: props.context === 'simulation' ? 24 : (10 * props.scale) + "px",
						}}
					>
						{TextVariables.textToData(data.subtitle.value)}
					</div>
				</div>
			</div>
		);
	}

	return null;
}